import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClarifyOption, DialogClarify} from '../../../services/dialog/dialog.models';

@Component({
  selector: 'app-clarify-options',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clarify-options.component.html',
})
export class ClarifyOptionsComponent {
  @Input({required: true}) clarify!: DialogClarify;
  @Input() selectedIndex?: number;
  @Output() optionSelected = new EventEmitter<ClarifyOption>();

  get isFreeText(): boolean {
    return this.clarify.question_type === 'free_text' || !this.clarify.options?.length;
  }

  get isCollapsed(): boolean {
    return this.selectedIndex != null;
  }

  get selectedLabel(): string | undefined {
    return this.clarify.options?.find(o => o.index === this.selectedIndex)?.label;
  }

  select(option: ClarifyOption): void {
    if (this.isCollapsed) return;
    this.optionSelected.emit(option);
  }
}
